<div id="site-header-wrapper">
    <nav id="site-header">
        <div>
            <a href="/">
                <img id="dji-logo" src="assets/dji-logo.svg" width="167px" height="28px" alt="DJI">
            </a>
        </div>

        <ul class="nav-menu">
            <li (mouseenter)="openDropdown('sectors')" (mouseleave)="onTriggerLeave()">Sectores</li>
            <li (mouseenter)="openDropdown('products')" (mouseleave)="onTriggerLeave()">Productos</li>
        </ul>

        <div id="nav-contact-btn">
            <a href="#contact-form-compact-container">CONTACTA CON NOSOTROS</a>
        </div>
    </nav>

    @if (isDropdownActive) {
    <app-navbar-dropdown (mouseenter)="openDropdown(dropdownType)" (mouseleave)="closeDropdown()" class="nav-dropdown"
        [dropdownType]="dropdownType"></app-navbar-dropdown>
    }
</div>